<template>
    <div>
        <referrals-is-patient-seen-modal
            v-if="showPatientSeenModal"
            :referral="referral"
            :showBellIcon="false"
            :totalNumber="totalNumber"
            :currentIndex="currentIndexPatient + currentIndexConsultation"
            :showCloseButton="false"
            @patient-seen="patientSeen"
            @skip-all="closeCompleteOverlayModal"
        ></referrals-is-patient-seen-modal>
        <common-modal v-if="showReferralsAddReportModal" width="medium" :transition="true" :showCloseButton="false">
            <referrals-add-report
                ref="referralAddNotesComponent"
                :redirectToReferral="false"
                :showSkipButton="true"
                :referral="referral"
                :totalNumber="totalNumber"
                :currentIndex="currentIndexPatient + currentIndexConsultation"
                @consultation-report-saved="consultationReportSaved"
                @consultation-report-skip="consultationReportSkip"
                @skip-all="closeCompleteOverlayModal"
            ></referrals-add-report>
        </common-modal>
        <common-notification ref="commonSuccessNotification" :content="notificationMessage"></common-notification>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    import ReferralsIsPatientSeenModal from 'components/page-elements/ReferralsIsPatientSeenModal'
    import ReferralsAddReport from 'components/page-elements/ReferralsAddReport'
    import ReferralsAPI from 'api/ReferralsAPI'
    import ReferralStatusEnum from '@/enums/ReferralStatusEnum'
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'
    import ReferralPathTypeEnum from '@/enums/ReferralPathTypeEnum'

    export default {
        mixins: [ScreenSizeDetectionMixin],

        components: {
            ReferralsIsPatientSeenModal,
            ReferralsAddReport,
        },

        data() {
            return {
                showPatientSeenModal: false,
                showReferralsAddReportModal: false,
                referralsConsultation: [],
                referralsPatient: [],
                referral: {},
                currentIndexPatient: 0,
                currentIndexConsultation: 0,
                notificationMessage: '',
                totalNumber: 0,
            }
        },

        methods: {
            patientSeen(event) {
                ReferralsAPI.updatePatientVisitStatus(this.referral.id, event.status).then(() => {
                    if (event.status === 'patient-seen' && !this.isTablet) {
                        this.showPatientSeenModal = false
                        this.showReferralsAddReportModal = true
                        this.showNotification(this.$t('pages.referrals.referrals_complete.patient_seen'))
                    } else {
                        this.showNotification(this.$t('pages.referrals.referrals_complete.patient_not_seen'))
                        this.moveToNextReferral()
                    }
                })
            },

            consultationReportSaved() {
                this.showNotification(this.$t('pages.referrals.referrals_complete.consultation_saved'))
                this.resetConsultationNoteModal()
                this.moveToNextReferral()
            },

            consultationReportSkip() {
                this.showNotification(this.$t('pages.referrals.referrals_complete.consultation_skipped'))
                this.resetConsultationNoteModal()
                this.moveToNextReferral()
            },

            resetConsultationNoteModal() {
                this.$refs.referralAddNotesComponent.selectedFiles = []
                this.$refs.referralAddNotesComponent.isSubmitDisabled = true
            },

            showNotification(message) {
                this.notificationMessage = message
                this.$refs.commonSuccessNotification.showNotification()
            },

            loadReferrals() {
                const query = {
                    status: `${ReferralStatusEnum.PATIENT_VISIT_PENDING},${ReferralStatusEnum.CONSULTATION_NOTES_PENDING}`,
                    limit: 30,
                    toDate: dayjs().utc().format('YYYY-MM-DD HH:mm:ss'),
                }
                ReferralsAPI.getList(ReferralPathTypeEnum.RECEIVED, this.$auth.getActiveMember()?.id, query).then((res) => {
                    if (!this.isTablet) {
                        this.referralsConsultation = res.filter(
                            (item) => item.status === ReferralStatusEnum.CONSULTATION_NOTES_PENDING,
                        )
                    }
                    this.referralsPatient = res.filter((item) => item.status === ReferralStatusEnum.PATIENT_VISIT_PENDING)
                    this.totalNumber = this.referralsConsultation.length + this.referralsPatient.length
                    this.moveToNextReferral()
                })
            },

            closeCompleteOverlayModal() {
                this.showPatientSeenModal = false
                this.showReferralsAddReportModal = false
                localStorage.setItem('referralsCompleted', true)

                window.dispatchEvent(
                    new CustomEvent('referrals-complete-localstorage-changed', {
                        detail: {
                            referralsCompleted: !!localStorage.getItem('referralsCompleted'),
                        },
                    }),
                )
            },

            moveToNextReferral() {
                this.showPatientSeenModal = false
                this.showReferralsAddReportModal = false
                if (this.currentIndexPatient < this.referralsPatient.length) {
                    this.referral = this.referralsPatient[this.currentIndexPatient]
                    this.currentIndexPatient = this.currentIndexPatient + 1
                    this.showPatientSeenModal = true
                    return
                }

                if (this.currentIndexConsultation < this.referralsConsultation.length) {
                    this.referral = this.referralsConsultation[this.currentIndexConsultation]
                    this.currentIndexConsultation = this.currentIndexConsultation + 1
                    this.showReferralsAddReportModal = true
                    return
                }

                this.closeCompleteOverlayModal()
            },
        },

        mounted() {
            if (
                localStorage.getItem('referralsCompleted') == 'false' &&
                !this.$auth.isUserPracticeOther() &&
                !this.$auth.isUserTemporaryPhysician()
            ) {
                this.loadReferrals()
            }
        },
    }
</script>
